import * as React from "react"
import { Route, Switch } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Header from "@smpu-web/globalmodules/header"
import Footer from "@smpu-web/globalmodules/footer"
import Landing from "./landing"
import Block from "@bappweb/block"
import "../assets/style.scss"
import Link from "@bappweb/link"
import Image from "@bappweb/image"

const Main = () => {
  const routes = React.useMemo(
    () => ({
      Landing,
      Result: () => <Loadable loader={() => import("./result")} />,
      // eslint-disable-next-line react/no-multi-comp
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )

  return (
    <>
      <Block className="bapp-main-container">
        <Block className="position-relative">
          <Block className="container">
          <Block className="bapp-page bapp-container bapp-page-has-padding bapp-page-has-footer">
            <Link href="https://www.akbank.com/" className="logo">
              <Image className="logo" path={"./img/ttbbilgiformu/logo.svg"} />
            </Link>
          </Block>
          </Block>
        </Block>
        <Block type="main" className="bapp-main">
          <Switch>
            <Route exact path="/" component={routes.Landing} />
            <Route component={routes.NotFound} />
          </Switch>
          <Footer />
        </Block>
      </Block>
    </>
  )
}

export default Main
